module.exports = __webpack_public_path__ + "img/card04.c433a4e2.png";